<template>
  <div class="fill-width">
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getMobileLayout">
        <b-col cols="12">
          <HeaderNewVersion />
        </b-col>
        <b-col cols="12">
          <CreateShaparakTransactionNewVersion
            v-if="getStepperPage === 'pageOne'"
          />
          <ShaparakFinalNewVersion v-else-if="getStepperPage === 'pageTwo'" />
          <ShaparakResultNewVersion
            v-else-if="getStepperPage === 'pageThree'"
          />
        </b-col>
      </b-row>
      <b-row v-else-if="!getMobileLayout">
        <DesktopLayoutHelperNewVersion>
          <template v-slot:body>
            <CreateShaparakTransactionNewVersion
              v-if="getStepperPage === 'pageOne'"
            />
            <ShaparakFinalNewVersion v-else-if="getStepperPage === 'pageTwo'" />
            <ShaparakResultNewVersion
              v-else-if="getStepperPage === 'pageThree'"
            />
          </template>
        </DesktopLayoutHelperNewVersion>
      </b-row>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import HeaderNewVersion from "@/components/HeaderNewVersion";
import CreateShaparakTransactionNewVersion from "@/components/Shaparak/NewVersion/CreateShaparakTranasctionNewVersion";
import ShaparakFinalNewVersion from "@/components/Shaparak/NewVersion/ShaparakFinalNewVersion";
import ShaparakResultNewVersion from "@/components/Shaparak/NewVersion/ShaparakResultNewVersion";
import DesktopLayoutHelperNewVersion from "@/components/DesktopLayoutHelperNewVersion";

export default {
  name: "ShaparakNewVersion",
  components: {
    DesktopLayoutHelperNewVersion,
    ShaparakResultNewVersion,
    ShaparakFinalNewVersion,
    CreateShaparakTransactionNewVersion,
    HeaderNewVersion,
  },
  data() {
    return {
      paymentId: null,
    };
  },
  computed: {
    ...mapGetters(["getStepperPage", "getMobileLayout"]),
  },
  methods: {
    ...mapMutations(["setStepperPage", "setIsCompName"]),
  },
  created() {
    this.setIsCompName("shaparak");
    this.setStepperPage("pageOne");
    this.paymentId = this.$route.query.id;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    }
  },
};
</script>

<style scoped>
.shaparakStepper {
  padding-bottom: 30px;
}
</style>
